import React from "react";

interface Props {
  email: server.dto.EmailMessage
}

const EmailFull = ({ email }: Props) => {
  const hasCc = email.recipientsCC != null && email.recipientsCC.length > 0;
  const hasBcc = email.recipientsBCC != null && email.recipientsBCC.length > 0;

  return <>
    <table className="s1_emailheader margin-bottom-mini">
      <tbody>
        <tr>
          <td className="s1_gray">{RESX.Message.lblTo}:</td>
          <td>{email.recipientsTo}</td>
        </tr>

        {hasCc && <tr>
          <td className="s1_gray">{RESX.Message.lblCC}:</td>
          <td>{email.recipientsCC}</td>
        </tr>}
        {hasBcc && <tr>
          <td className="s1_gray">{RESX.Message.lblBcc}:</td>
          <td>{email.recipientsBCC}</td>
        </tr>}
        <tr>
          <td className="s1_gray">{RESX.Message.Subject}:</td>
          <td>{email.subject}</td>
        </tr>
      </tbody>
    </table>
    <div className="s1_small" dangerouslySetInnerHTML={{
      __html: email.htmlBody
    }}></div>
  </>;
};

export default EmailFull;